import { render, staticRenderFns } from "./RegisterFormPartner.vue?vue&type=template&id=ca38a72e&scoped=true&"
import script from "./RegisterFormPartner.vue?vue&type=script&lang=js&"
export * from "./RegisterFormPartner.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormPartner.vue?vue&type=style&index=0&id=ca38a72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca38a72e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca38a72e')) {
      api.createRecord('ca38a72e', component.options)
    } else {
      api.reload('ca38a72e', component.options)
    }
    module.hot.accept("./RegisterFormPartner.vue?vue&type=template&id=ca38a72e&scoped=true&", function () {
      api.rerender('ca38a72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterFormPartner.vue"
export default component.exports